import SoccerAgeCalculator from "./components/SoccerAgeCalculator";
import "./App.css";

function App() {
  return (
    <div className="App">
      <SoccerAgeCalculator />
    </div>
  );
}

export default App;
